import { createAppSlice } from 'utils/createAppSlice'
import { defaultInitialState } from 'utils/defaultInitialState.ts'
import { RegisterSliceInitialState } from 'components/Auth/Register/Register.types.ts';
import { registerFormBodyInitialState } from 'components/Auth/Register/Register.utils.ts';

const registerSliceInitialState: RegisterSliceInitialState = {
    ...defaultInitialState,
    editableFormBody: registerFormBodyInitialState,
}

export const registerSlice = createAppSlice<RegisterSliceInitialState>('register', registerSliceInitialState)

export default registerSlice.reducer
